import { useMemo } from "react";

import type { BaseLeadsSearchRow, LeadsSearchDetailsRowList, LeadsSearchTableData } from "../types";
import { enrichRowsWithDetailedData } from "../utils";

export function useEnrichedTableData<
    R extends BaseLeadsSearchRow,
    T extends LeadsSearchTableData<R> = LeadsSearchTableData<R>,
>(tableData: T | undefined, detailedResults?: LeadsSearchDetailsRowList<R>): T | undefined {
    const enrichedRows = useMemo(
        () => enrichRowsWithDetailedData(tableData?.rows ?? [], detailedResults),
        [tableData?.rows, detailedResults],
    );

    return useMemo(
        () => (tableData ? ({ ...tableData, rows: enrichedRows } as T) : tableData),
        [tableData, enrichedRows],
    );
}
